import 'svelte/internal/disclose-version';

Skeleton[$.FILENAME] = 'src/components/Skeleton.svelte';

import * as $ from 'svelte/internal/client';

var root = $.add_locations($.from_html(`<div class="block svelte-tl058d"></div>`), Skeleton[$.FILENAME], [[7, 4]]);
var root_1 = $.add_locations($.from_html(`<div class="grid svelte-tl058d" aria-hidden="true"></div>`), Skeleton[$.FILENAME], [[5, 0]]);

const $$css = {
	hash: 'svelte-tl058d',
	code: '\n  .grid.svelte-tl058d {\n    display: grid;\n    grid-template-columns: repeat(auto-fill, minmax(248px, 1fr));\n    gap: 20px;\n  }\n  .block.svelte-tl058d {\n    height: var(--h);\n    border-radius: var(--radius);\n    background: linear-gradient(100deg, var(--card) 30%, var(--card-soft) 50%, var(--card) 70%);\n    background-size: 220% 100%;\n    animation: svelte-tl058d-shimmer 1.4s infinite linear;\n    border: 1px solid var(--line);\n  }\n  @keyframes svelte-tl058d-shimmer {\n    from { background-position: 140% 0; }\n    to { background-position: -40% 0; }\n  }\n\n/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiU2tlbGV0b24uc3ZlbHRlIiwic291cmNlcyI6WyJTa2VsZXRvbi5zdmVsdGUiXSwic291cmNlc0NvbnRlbnQiOlsiPHNjcmlwdD5cbiAgbGV0IHsgY291bnQgPSA4LCBoZWlnaHQgPSAyNjAgfSA9ICRwcm9wcygpO1xuPC9zY3JpcHQ+XG5cbjxkaXYgY2xhc3M9XCJncmlkXCIgYXJpYS1oaWRkZW49XCJ0cnVlXCI+XG4gIHsjZWFjaCBBcnJheShjb3VudCkgYXMgXywgaSAoaSl9XG4gICAgPGRpdiBjbGFzcz1cImJsb2NrXCIgc3R5bGU9XCItLWg6IHtoZWlnaHR9cHhcIj48L2Rpdj5cbiAgey9lYWNofVxuPC9kaXY+XG5cbjxzdHlsZT5cbiAgLmdyaWQge1xuICAgIGRpc3BsYXk6IGdyaWQ7XG4gICAgZ3JpZC10ZW1wbGF0ZS1jb2x1bW5zOiByZXBlYXQoYXV0by1maWxsLCBtaW5tYXgoMjQ4cHgsIDFmcikpO1xuICAgIGdhcDogMjBweDtcbiAgfVxuICAuYmxvY2sge1xuICAgIGhlaWdodDogdmFyKC0taCk7XG4gICAgYm9yZGVyLXJhZGl1czogdmFyKC0tcmFkaXVzKTtcbiAgICBiYWNrZ3JvdW5kOiBsaW5lYXItZ3JhZGllbnQoMTAwZGVnLCB2YXIoLS1jYXJkKSAzMCUsIHZhcigtLWNhcmQtc29mdCkgNTAlLCB2YXIoLS1jYXJkKSA3MCUpO1xuICAgIGJhY2tncm91bmQtc2l6ZTogMjIwJSAxMDAlO1xuICAgIGFuaW1hdGlvbjogc2hpbW1lciAxLjRzIGluZmluaXRlIGxpbmVhcjtcbiAgICBib3JkZXI6IDFweCBzb2xpZCB2YXIoLS1saW5lKTtcbiAgfVxuICBAa2V5ZnJhbWVzIHNoaW1tZXIge1xuICAgIGZyb20geyBiYWNrZ3JvdW5kLXBvc2l0aW9uOiAxNDAlIDA7IH1cbiAgICB0byB7IGJhY2tncm91bmQtcG9zaXRpb246IC00MCUgMDsgfVxuICB9XG48L3N0eWxlPlxuIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiI7QUFXQSxFQUFFLG1CQUFLLENBQUM7QUFDUixJQUFJLGFBQWE7QUFDakIsSUFBSSw0REFBNEQ7QUFDaEUsSUFBSSxTQUFTO0FBQ2I7QUFDQSxFQUFFLG9CQUFNLENBQUM7QUFDVCxJQUFJLGdCQUFnQjtBQUNwQixJQUFJLDRCQUE0QjtBQUNoQyxJQUFJLDJGQUEyRjtBQUMvRixJQUFJLDBCQUEwQjtBQUM5QixJQUFJLHlCQUFXLDRCQUE0QjtBQUMzQyxJQUFJLDZCQUE2QjtBQUNqQztBQUNBLEVBQUUseUJBQVc7QUFDYjtBQUNBO0FBQ0E7In0= */'
};

export default function Skeleton($$anchor, $$props) {
	$.check_target(new.target);
	$.push($$props, true, Skeleton);
	$.append_styles($$anchor, $$css);

	let count = $.prop($$props, 'count', 3, 8),
		height = $.prop($$props, 'height', 3, 260);

	var $$exports = { ...$.legacy_api() };
	var div = root_1();

	$.add_svelte_meta(
		() => $.each(div, 21, () => Array(count()), $.index, ($$anchor, _) => {
			var div_1 = root();

			$.template_effect(() => $.set_style(div_1, `--h: ${height() ?? ''}px`));
			$.append($$anchor, div_1);
		}),
		'each',
		Skeleton,
		6,
		2
	);

	$.reset(div);
	$.append($$anchor, div);

	return $.pop($$exports);
}